<template lang="pug">
    .home.beipanjiang-home
      aside.aside
        .nav
          .system-name(@click="$router.push('/')") 时均数据分析
            //- span 除湿数据采集与监视控制系统
          .nav-bar
            .nav-buttom
              router-link(to="/averageAnalysis/simpleAverageData?bridgeId=077b2024-c60f-4f34-80f9-467bb24cc324") 统计数据表
              router-link(to="/averageAnalysis/dataHistory?bridgeId=077b2024-c60f-4f34-80f9-467bb24cc324&scenarioId=TBD") 数据历史
      
      TimeBlock.time-block(bridgeName="ADMIN", size="radar-size")
    </template>

<script>
import TimeBlock from "@/components/TimeBlock";

export default {
  name: "Index",
  components: {
    TimeBlock,
  },
  data() {
    return {
      timer: null,
      bridgeId: "077b2024-c60f-4f34-80f9-467bb24cc324",
      historyScenarioList: [],
      radarBlockDaysCount: 3,
      radarBlockHumidityLine: 50,
      radarBlockDelayInit: false,
      radarBlockAllowUserSelectDevice: true,
      radarBlockIgnoreEmptyData: true,
      radarBlockFullResultDict: {},
    };
  },
  computed: {},
  mounted() {
    this.timer = setInterval(() => {
      this.checkAuth();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    checkAuth() {
      this.$http.get("/auth/LoginInfo").then((res) => { });
    },
    initNextRadar(refName) {
      let radar = this.$refs[refName];
      if (radar) {
        setTimeout(() => {
          radar.initChart();
        }, 1000);
      }
    },
    setRadarDataHandler(polygonNamePassRateDict) {
      for (let polygonName in polygonNamePassRateDict) {
        this.$set(this.radarBlockFullResultDict, polygonName, polygonNamePassRateDict[polygonName]);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  min-height: 600px;
  position: relative;
  background: url("../../assets/image/qingshui/qingshui.jpg") center no-repeat;
  background-size: cover;

  &.beipanjiang-home {
    min-width: 1550px;
  }

  .time-block {
    position: absolute;
    top: 100px;
    right: 25px;
  }

  .radar-block1 {
    position: absolute;
    bottom: 75px;
    right: 775px;
  }

  .radar-block2 {
    position: absolute;
    bottom: 75px;
    right: 1025px;
  }

  .radar-block3 {
    position: absolute;
    bottom: 75px;
    right: 25px;
  }

  .radar-block4 {
    position: absolute;
    bottom: 75px;
    right: 275px;
  }

  .radar-block5 {
    position: absolute;
    bottom: 75px;
    right: 525px;
  }

  .radar-block6 {
    position: absolute;
    top: 100px;
    right: 275px;
  }

  .aside {
    position: relative;
    width: 250px;
    height: 100%;
    color: #fff;
    min-width: 260px;
    text-align: center;
    box-shadow: 0 0 30px 0 #000;
    overflow: hidden;
    box-sizing: border-box;
    background: url("../../assets/image/qingshui/qingshui1.png") center no-repeat fixed;
    background-size: cover;

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background: transparent;
    }

    ::-webkit-scrollbar-corner {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: #84a4c2;
    }

    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
      border-radius: 0;
      background-color: transparent;
    }

    .nav {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 1;

      a {
        display: block;
        width: 58%;
        height: 48px;
        margin: 0 auto 20px auto;
        border: none;
        line-height: 48px;
        border-radius: 5px;
        color: #4b4e50;
        background: #cadce9;
        cursor: pointer;
        text-decoration: none;

        &.same-line {
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: 18px;
        }

        p {
          margin: 0;
        }

        &:hover {
          color: #fff;
          background: #33a2f5;
        }
      }

      .system-name {
        height: 75px;
        font-weight: 700;
        font-size: 40px;
        margin: 75px 0;
        cursor: pointer;

        span {
          display: block;
          font-size: 18px;
        }
      }

      .nav-bar {
        height: calc(100% - 250px);
        overflow-y: auto;
      }
    }
  }
}
</style>